<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Basic data')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormDropdown fieldName="manager_id"
                                  label="Manager"
                                  size="4"
                                  showClear
                                  :isFormDisabled="isFormDisabled"
                                  :filtering="true"
                                  :filter="(event) => onFilter(event, 'managers')"
                                  :options="select?.managers"
                                  v-model:field="crud.manager_id" />

                    <FormMultiselect fieldName="worker_deputies"
                                     label="Deputies"
                                     size="8"
                                     showClear
                                     :isFormDisabled="isFormDisabled"
                                     :options="deputiesFiltered"
                                     :filter="(event) => onFilter(event, 'deputies')"
                                     v-model:field="crud.worker_deputies" />

                    <FormCalendar fieldName="deputy_from"
                                  label="From day"
                                  size="4"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.deputy_from" />

                    <FormCalendar fieldName="deputy_to"
                                  label="To day"
                                  size="4"
                                  :isFormDisabled="isFormDisabled"
                                  v-model:field="crud.deputy_to" />

                    <FormInputToggleButton fieldName="is_active"
                                           label="Is record active?"
                                           size="4"
                                           :default="true"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.is_active" />

                    <FormEditor fieldName="description"
                                label="Description"
                                :editorStyle="{ height: '120px' }"
                                :isFormDisabled="isFormDisabled"
                                v-model:field="crud.description" />
                </div>
            </TabPanel>

            <TabPanel :header="__('Changelog')"
                      headerClass="form-tab-header">
                <ChangeLog :log="crud?.log" />
            </TabPanel>
        </TabView>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import {
    validation,
    onFilterService,
    initForm,
} from "@pages/Helper/crud_utils.js";
import FormDropdown from "@crud/FormDropdown.vue";
import FormMultiselect from "@crud/FormMultiselect.vue";
import FormCalendar from "@crud/FormCalendar.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";
import FormEditor from "@crud/FormEditor.vue";
import FormButtons from "@crud/FormButtons.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import { __, deepCopy } from "@helper/utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);
const autoSave = ref(false);

const options = ["managers"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref(null);
const deputiesFiltered = ref([]);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
    deputiesFiltered.value = deepCopy(select.value?.managers);
});

// -----------------------------------------------------

const onFilter = async (event, option) => {
    if (option === "deputies") {
        const tempSelect = ref({});
        await onFilterService(event, "managers", tempSelect, isLoading);
        deputiesFiltered.value = deepCopy(tempSelect.value.managers);
    } else {
        await onFilterService(event, option, select, isLoading);
    }
};

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
